<template>
  <div>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-right="40"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            v-bind:value="value"
            v-on:input="$emit('input', $event)"
            :label="label"
            prepend-icon="mdi-calendar"
            v-bind="attrs"
            v-on="on"
            v-on:change="$emit('change', $event)"
            dense
            outlined
            :disabled="disabled"
        ></v-text-field>
      </template>
      <v-date-picker
          v-bind:value="value"
          v-on:input="$emit('input', $event)"
          @input="menu = false"
          v-on:change="$emit('change', $event)"
      ></v-date-picker>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: "BaseFormatDateField",
  props: ['value', 'label', 'disabled'],
  data() {
    return {
      menu: false,
    }
  },
  computed: {},
  methods: {},
};
</script>


